import GraduateIcon from './Icon/GraduateIcon';
import AwardsIcon from './Icon/AwardsIcon';
import QuestionIcon from './Icon/QuestionIcon';
import ScheduleIcon from './Icon/ScheduleIcon';
import TendencyIcon from './Icon/TendencyIcon';
import LikeIcon from '../icon/LikeIcon';
import WritePortfolioIcon from './Icon/WritePortfolioIcon';
import ProfessionIcon from './Icon/ProfessionIcon';
import WriteIcon from '#assets/icon/WriteIcon';

export const PROFILE_LIST_INFO = [
  {
    icon: GraduateIcon,
    title: '경력 입력',
    content: '나의 경력을 입력하고 차별점을 강화해요',
    routing: '/profile/qualification/careers',
    hide: false,
    type: 'carrer'
  },
  {
    icon: AwardsIcon,
    title: '자격증 등록',
    content: '나의 자격증을 등록하고 차별점을 강화해요',
    routing: '/profile/qualification/licenses',
    hide: false,
    type: 'license'
  },
  {
    icon: ScheduleIcon,
    title: '수업 등록',
    content: '수업 정보와 일정, 장소를 등록하고 신규 회원을 창출해요',
    routing: '/profile/class/register',
    hide: false,
    type: 'lecture'
  },
  {
    title: '질문 답변 작성',

    icon: TendencyIcon,
    content: '고민을 해결하고 나의 전문성을 나타내요',
    routing: '/community/qna',
    hide: false,
    type: 'qna'
  },
  {
    icon: WriteIcon,
    title: '운동 가이드 작성',
    content: '지식을 공유하고 나의 전문성을 나타내요',
    routing: '/community/information',
    type: 'exercies'
  },
  {
    icon: WritePortfolioIcon,
    title: '트레이닝 성과 등록',
    content: '회원 변화 사례를 등록하고 PT 상담 전환율을 높여요',
    routing: '/profile/clinical-data/form',
    hide: false,
    type: 'portfolio'
  },
  {
    icon: LikeIcon,
    title: '리뷰 요청',
    content: '리뷰를 수집하고 PT 상담 전환율을 높여요',
    routing:
      'https://slashpage.com/fibudtrainer/4z7pvx2k99vwv2ek8653?post=7916x82rpn1n924kpyg3',
    hide: false,
    type: 'review'
  }
];
